class CarStorageCountController {

    static get BookmarkListAttribute() {
        return '[data-bookmarklist]';
    }

    static get ComparisonListAttribute() {
        return '[data-comparisonlist]';
    }

    /**
     * @param {Object} bookmarkListStorage
     * @param {Object} comparisonListStorage
     */
    constructor(bookmarkListStorage, comparisonListStorage) {
        this.bookmarkListStorage = bookmarkListStorage;
        this.storageComparisonList = comparisonListStorage;

        this.$clickListener = $('.car-list');
        this.$countBookmarkList = $('[data-count-bookmarklist]');
        this.$countComparisonList = $('[data-count-comparisonlist]');

        this._setEvents();
    }

    /**
     * @returns {CarStorageCountController}
     */
    updateStorageCount() {
        this.$countBookmarkList.text(this.bookmarkListStorage.count());
        this.$countComparisonList.text(this.storageComparisonList.count());
    }

    /**
     * @returns {CarStorageCountController}
     */
    setStates() {
        this
            ._loopAndChangeButtonState(this.bookmarkListStorage, 'data-bookmarklist')
            ._loopAndChangeButtonState(this.storageComparisonList, 'data-comparisonlist');

        return this;
    }

    removeCarFromBookmarkListStorage(carId) {
        this.bookmarkListStorage.removeCar(carId);
        this.updateStorageCount();
    }

    removeCarFromComparisonListStorage(carId) {
        this.storageComparisonList.removeCar(carId);
        this.updateStorageCount();
    }

    /**
     * @param {Object} listStorage
     * @param {string} dataAttribute
     * @returns {CarStorageCountController}
     * @private
     */
    _loopAndChangeButtonState(listStorage, dataAttribute) {
        for (let key in listStorage.findAll()) {
            let $button = $('[' + dataAttribute + '][data-car-id="' + key + '"]');
            this._changeButtonState($button);
        }

        return this;
    }

    /**
     * @param {jQuery} $button
     * @returns {CarStorageCountController}
     * @private
     */
    _changeButtonState($button) {
        let newState = 1 - parseInt($button.data('state'));
        let classToToggle = $button.data('icon-toggle'),
            $buttonIcon = $button.children('span');

        $button
            .data('state', newState);

        if ($buttonIcon.hasClass(classToToggle)) {
            $buttonIcon.removeClass(classToToggle).addClass(classToToggle + '-o');
        } else {
            $buttonIcon.removeClass(classToToggle + '-o').addClass(classToToggle);
        }

        return this;
    }

    /**
     * @param {Object} listStorage
     * @param {jQuery} $button
     * @returns {CarStorageCountController}
     * @private
     */
    _toggleState(listStorage, $button) {
        let state = $button.data('state');
        let carId = $button.data('car-id');

        if (0 === state) {
            listStorage.addCar(carId);
        } else {
            listStorage.removeCar(carId);
        }

        return this._changeButtonState($button);
    }

    /**
     * @returns {CarStorageCountController}
     * @private
     */
    _setEvents() {
        let self = this;

        this.$clickListener
            .on('click', CarStorageCountController.BookmarkListAttribute, function (e) {
                e.preventDefault();

                self._toggleState(self.bookmarkListStorage, $(this))
                    .updateStorageCount();

                return false;
            })
            .on('click', CarStorageCountController.ComparisonListAttribute, function (e) {
                e.preventDefault();

                self._toggleState(self.storageComparisonList, $(this))
                    .updateStorageCount();

                return false;
            });

        return this;
    }
}
